import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import DOMPurify from "dompurify";
import { api } from "@/lib/api";

const PageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPage(null);
    setMissing(false);
    api
      .get(`/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => setMissing(true));
  }, [slug]);

  if (missing) {
    return (
      <main className="flex min-h-[70vh] flex-col items-center justify-center bg-cream px-4 text-center">
        <p className="font-serif text-3xl text-espresso">This page does not exist</p>
        <Link
          to="/"
          className="mt-6 font-mono text-[11px] uppercase tracking-[0.3em] text-gold-muted underline-offset-4 hover:underline"
        >
          Back to home
        </Link>
      </main>
    );
  }

  return (
    <main data-testid="content-page" className="min-h-screen bg-cream px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/"
          className="group inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-espresso/60 transition-colors hover:text-gold-accent"
        >
          <ArrowLeft size={13} className="transition-transform duration-300 group-hover:-translate-x-1" />
          Home
        </Link>
        {page && (
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.35em] text-gold-muted">
              Aarmira — Fashion and Fortune
            </p>
            <h1 data-testid="content-page-title" className="mt-3 font-serif text-4xl tracking-tight text-espresso sm:text-5xl">
              {page.title}
            </h1>
            <div className="mt-4 h-px w-16 bg-gold" />
            {page.content_html ? (
              <div
                data-testid="content-page-body"
                className="about-content mt-8 text-base text-espresso/75"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.content_html) }}
              />
            ) : (
              <p data-testid="content-page-empty" className="mt-8 text-base leading-relaxed text-espresso/50">
                We're preparing this page. Please check back shortly.
              </p>
            )}
          </motion.div>
        )}
      </div>
    </main>
  );
};

export default PageView;
